import { ClientStateEnums } from "src/app/enum/client-state-enums";

export class ClientImportModel {
  counter: number = 0;
  typeDocumentId: number = 0;
  document: string = "";
  digitVerification: number = 0;
  document2: string = "";
  digitVerification2: number = 0;
  typePersonId: number = 0;
  names: string | null = null;
  lastNames: string | null = null;
  businessName: string = "";
  comercialName: string = "";
  address: string = "";
  email: string | null = null;
  taxEmail: string | null = null;
  phone: string = "";
  alterPhone: string | null = null;
  departmentCode: string = "";
  cityCode: string = "";
  swExpirationDays: boolean = false;
  expirationDays: number = 0;
  swIvaRetainer: boolean = false;
  swIvaResponsible: boolean = false;
  swDeclarant: boolean = false;
  swGreatContributor: boolean = false;
  swSimpleTaxRegime: boolean = false;
  clientStateId: number = ClientStateEnums.activo;
  observation: string | null = null;

  constructor(counter: number,
    typeDocumentId: number,
    document: string,
    digitVerification: number,
    document2: string,
    digitVerification2: number,
    typePersonId: number,
    names: string | null,
    lastNames: string | null,
    businessName: string,
    comercialName: string,
    address: string,
    email: string | null,
    taxEmail: string | null,
    phone: string,
    alterPhone: string | null,
    departmentCode: string,
    cityCode: string,
    swExpirationDays: boolean,
    expirationDays: number,
    swIvaRetainer: boolean,
    swIvaResponsible: boolean,
    swDeclarant: boolean,
    swGreatContributor: boolean,
    swSimpleTaxRegime: boolean,
    clientStateId: number,
    observation: string | null
  ) {
    this.counter = counter;
    this.typeDocumentId = typeDocumentId;
    this.document = document;
    this.digitVerification = digitVerification;
    this.document2 = document2;
    this.digitVerification2 = digitVerification2;
    this.typePersonId = typePersonId;
    this.names = names;
    this.lastNames = lastNames;
    this.businessName = businessName;
    this.comercialName = comercialName;
    this.address = address;
    this.email = email;
    this.taxEmail = taxEmail;
    this.phone = phone;
    this.alterPhone = alterPhone;
    this.departmentCode = departmentCode;
    this.cityCode = cityCode;
    this.swExpirationDays = swExpirationDays;
    this.expirationDays = expirationDays;
    this.swIvaRetainer = swIvaRetainer;
    this.swIvaResponsible = swIvaResponsible;
    this.swDeclarant = swDeclarant;
    this.swGreatContributor = swGreatContributor;
    this.swSimpleTaxRegime = swSimpleTaxRegime;
    this.clientStateId = clientStateId;
    this.observation = observation;
  }
}